import { useTranslation } from "react-i18next";

const Terms = () => {
  const { t } = useTranslation();
  return (
    <main>
      <article className="py-20">
        <div className="w-11/12 mx-auto">
          <h1 className="text-[24px] md:text-[32px] text-mainBlue space-y-10 font-semibold text-center">
            {t("termsCondition")}
          </h1>
          <section className="space-y-10">
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("definitionAndNomenclature")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("transportationMeans")}</p>
                <p>{t("containersAndTransport")}</p>
                <p>{t("shippingIncludes")}</p>
                <p>{t("freightMeans")}</p>
                <p>{t("theTermOwner")}</p>
                <p>{t("theTermTrader")}</p>
                <p>{t("aPersonIncludes")}</p>
                <p>{t("subcontractorIncludes")}</p>
                <p>{t("generalConditions")}</p>
                <p>{t("vesselMeans")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("billOfLading")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("theConsignment")}</p>
                <p>{t("sendersObligation")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("rightToInspect")}
              </h2>
              <p className="font-medium text-mainGray">
                {t("megtlogisticsReservesTheRight")}
              </p>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("seizureOfTransported")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("megtlogisticsReservesTheRightToInspect")}</p>
                <p>{t("ifTheCarrierDoes")}</p>
                <p>{t("aContainerPackaging")}</p>
                <p>{t("bUnsuitability")}</p>
                <p>{t("cUnsuitabilityOfTheContainer")}</p>
                <p>{t("dImproperAdjustment")}</p>
                <p>{t("theMerchantIsResponsible")}</p>
                <p>{t("sheShipperMustInspect")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("shippingFees")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("fullShippingCosts")}</p>
                <p>{t("theCarrierMay")}</p>
                <p>{t("allAmountsPayable")}</p>
                <p>{t("lawsRelatedToTheMode")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("issuesAffectingPerformance")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("fullShippingCosts")}</p>
                <p>{t("theCarrierMay")}</p>
                <p>{t("allAmountsPayable")}</p>
                <p>{t("lawsRelatedToTheMode")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("notificationUnLoading")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("fullShippingCosts")}</p>
                <p>{t("theCarrierMay")}</p>
                <p>{t("allAmountsPayable")}</p>
                <p>{t("lawsRelatedToTheMode")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("limitationOfLiability")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("directLossMeans")}</p>
                <p>{t("megtlogisticsShallNotBe")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("exclusionOfLiability")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("theMerchantUnderTakesNotProvide")}</p>
                <p>{t("theShipperAlsoWarrants")}</p>
                <p>{t("theShipperAlsoWarrants")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("claims")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("megtlogisticsMustBeNotified")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("restrictedAndPerishableItems")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("restrictedAndPerishableItemsText")}</p>
                <p>{t("restrictedAndPerishableItemsText1")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("insurance")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("insurancePolicy")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("definitions")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("definitions1")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("carrier_terms")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("carrier_terms_clause")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("shippingAlt")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("shipping_terms")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("feesAndInvoice")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("feesAndInvoiceText")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("commercialRegulations")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("commercialRegulationsText")}</p>
                <p>{t("shipperIndemnity")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("confidentiality")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("confidentialityText")}</p>
                <p>{t("confidentialityDisclosure1")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("waiver")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("waiver_clause")}</p>
                <p>{t("carrier_assignment")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("shipper_consent")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("shipper_consent_clause")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("severability")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("severabilityText")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("governing_law")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("governing_law_text")}</p>
              </div>
            </div>
          </section>
        </div>
      </article>
    </main>
  );
};

export default Terms;
